import React, { Component } from 'react';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import '@progress/kendo-theme-default/dist/all.css';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { connect } from 'react-redux';
import {
	fetchPositions,
	fetchPositionGroups,
	addPosition,
	deletePosition,
	updatePosition
} from '../../../../../Redux/Actions/Admin/ManagePositionActions';
import { toastr } from '../../../../../Redux/Actions/CommonActions';
import AdminHeader from '../../../AdminHeader/AdminHeader';
import cellWithEditing from './CellWithEditing';
import PositionForm from './PositionForm';
import Search from '../../../Search';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import '../ManageUsers/ManageUser.scss';
import axios from 'axios';
import { PositionsLoader } from './PositionsLoader';
import { ROOT_API_URL } from '../../../../../api-config';
import { auth } from '../../../../../services/auth.service';
import { Alert } from 'reactstrap';

const FileDownload = require('js-file-download');

class ManagePositions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isSubmitted: false,
            positionInEdit: {},
            isPopupVisible: false,
            positions: { data: [], total: 0 },
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Description", dir: "asc" }]
            },
            alertVisible: false,
            alertColor: "danger",
            alertMessage: ""
        };
    }

    componentDidMount() {
        this.props.fetchPositionGroups();
    }

    dataStateChange = (e) => {

        if (e.data && e.data.filter && e.data.filter.filters) {
            var filters = e.data.filter.filters;

            for (var i = 0; i < filters.length; i++) {
                if (filters[i].field && filters[i].field == "RankingInt") {
                    var operator = filters[i].operator;

                    if (!filters[i].value && (operator == "lt" || operator == "lte" || operator == "gt" || operator == "gte")) {

                        filters[i].value = 0;

                    }

                } else if (filters[i].value == null) {
                    filters[i].value = "";
                }
            }
        }

        this.setState({
            ...this.state,
            dataState: e.data
        });
    }

    dataRecieved = (positionsFetched) => {
        this.setState({
            ...this.state,
            positions: positionsFetched,
            isLoading: false
        });
        console.log('positions Fetched', positionsFetched);

        if (positionsFetched.total == 0 && document.getElementsByClassName("k-grid-header-wrap").length != 0) {
            let t = document.getElementsByClassName("k-grid-header-wrap")[0].className = "horizontal-scroll";
        }
        else if (positionsFetched.total != 0 && document.getElementsByClassName("horizontal-scroll").length != 0) {
            document.getElementsByClassName("horizontal-scroll")[0].className = "k-grid-header-wrap";
        }
    }

    edit = (dataItem) => {
        this.setState({
            positionInEdit: Object.assign({}, dataItem),
            isPopupVisible: true
        });
    };

    cancel = () => {
        this.setState({ isPopupVisible: false })
    };

    stringifyObj = (arr) => {
        let t = [...arr];
        if (!t) {
            return null;
        }
        else {
            for (var i = 0; i < t.length; i++) {
                var element = { ...t[i] };
                for (var key in t[i]) {
                    element[key] = element[key] + '';
                }
                t[i] = element;
            }
            return t;
        }
    }

    exportToExcel = () => {
        var Filters = this.state.dataState.filter ? this.stringifyObj([...this.state.dataState.filter.filters]) : null;
        var Sorts = this.state.dataState.sort ? this.stringifyObj([...this.state.dataState.sort]) : null;
        var KendoGridQuery = {
            Filters: Filters ? Filters.slice() : [],
            Sorts: Sorts ? Sorts.slice() : []
        }

        axios.get(ROOT_API_URL + "/ManagePosition/ExportToExcel?queryArguments=" + JSON.stringify(KendoGridQuery), { headers: auth.authHeader() })
            .then((response) => {
                FileDownload(response.data, 'Positions.csv');
            }).catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to export to excel.';

                this.setState({
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    }

    toggleActive = (dataItem) => {
        dataItem.IsActive = !dataItem.IsActive;
        dataItem.Ranking = Number(dataItem.Ranking);
        delete dataItem.PositionGroup;

        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Description", dir: "asc" }]
            },
        });
        axios
            .post(`${ROOT_API_URL}/ManagePosition/DeletePosition`, dataItem, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to delete the position.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    };

    addNew = () => {
        this.setState({
            isPopupVisible: true,
            positionInEdit: {}
        });
    }

    save = (model) => {
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Description", dir: "asc" }]
            },
        });
        axios
            .post(`${ROOT_API_URL}/ManagePosition/SavePosition`, model, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to save the position.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    }

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    }

    render() {
        return (
            <div id={"positions-grid"}>
                <AdminHeader />
                {this.state.isLoading ?
                    (<div>
                        <IsLoading message="Loading positions" />
                    </div>

                    ) :
                    (
                        <div>
                            <Alert
                                color={this.state.alertColor}
                                isOpen={this.state.alertVisible}
                                toggle={() => {
                                    this.setState({ alertVisible: false, alertMessage: "" })
                                }}
                            >
                                {this.state.alertMessage}
                            </Alert>
                            <Grid
                                style={{ width: '80vw', height: '80vh' }}
                                filterable={true}
                                sortable={true}
                                pageable={true}
                                total={this.state.positions.total}
                                {...this.state.dataState}
                                {...this.state.positions}
                                onDataStateChange={this.dataStateChange}
                                resizable
                                reorderable={true}
                            >
                                <GridToolbar>
                                    {/*<div className="admin-grid-toolbar-box1">
                                        <Search customFunc={this.filterSize} />
                                        <Switch
                                            // style="width:70px"
                                            filter="boolean"
                                            onChange={this.handleChange}
                                            onLabel={'Active'}
                                            offLabel={'InActive'}
                                            checked={this.state.toggled}
                                        />
                                    </div>*/}

                                    <div className="admin-grid-toolbar-box2">
                                        <button onClick={this.addNew} className="admin-k-button">
                                            <i className="fas fa-plus-circle"></i>
                                            <span>ADD NEW</span>
                                        </button>
                                        <button title="Export PDF" className="admin-k-button" onClick={this.exportToExcel}>
                                            <i className="fas fa-file-export"></i>
                                            EXPORT TO EXCEL
                                        </button>
                                    </div>
                                </GridToolbar>
                                <Column filterable={false} cell={cellWithEditing(this.edit, this.toggleActive)} />
                                <Column field="RankingInt" title="Ranking" filter="numeric" />
                                <Column field="Description" title="Name" filter="text" />
                                <Column field="PositionGroup" title="Group" filter="text" />
                                <Column field="IsActive" title="Is Active" width="150vw" filter="boolean"/>
                            </Grid>
                        </div>
                    )
                }
                <div>
                    {!this.state.isSubmitted ?
                        <PositionsLoader
                            dataState={this.state.dataState}
                            onDataRecieved={this.dataRecieved}
                        />
                        : ""
                    }
                </div>
                <div>
                    {
                        this.state.isPopupVisible ? (
                            <PositionForm
                                dataItem={this.state.positionInEdit}
                                save={this.save}
                                cancel={this.cancel}
                                positionGroups={this.props.position.positionGroups}
                            />
                        ) : ""
                    }
                </div>
            </div>

        );
    }
}

function mapStateToProps(state) {
	return {
		position: state.position,
		common: state.common
	};
}

export default connect(mapStateToProps, {
    fetchPositions,
	fetchPositionGroups,
	addPosition,
	deletePosition,
	updatePosition,
	toastr
})(ManagePositions);
